const s=({closeness:s})=>null!=s&&void 0!==s?`closeness:1:${s}`:"closeness:0";export{s as buildDimension6};
